import { randomId } from "@mantine/hooks";
import { Flex } from "@mantine/core";
import { Fragment, useCallback } from "react";

import { type ISummaryItem } from "../../../../../../pages/Summary/Summary.types";
import { StyledTd } from "../../../../../../styled";
import { ReviewText } from "../../ReviewsTable.styled";
import { handleRoles } from "../SummaryItemRow.utils";
import { DateTimeDisp } from "src/components/shared/DateTime";
import { useSelector } from "src/redux/hooks";

interface Props {
  row: ISummaryItem;
  disabled: boolean | undefined;
  red?: boolean;
}

const RolesCells = ({ row, disabled, red }: Props) => {
  const { rolename: role, medroles } = useSelector(state => state.permsSlice);
  const userRoles = [...(medroles ?? []), role];
  const renderRoles = useCallback(
    (type: "pri" | "sec") => {
      let { roles, option, color, date } = handleRoles(row, type, userRoles);
      const blue = color === "blue";
      const red = color === "red";
      const green = color === "green";
      disabled = color === "gray" || disabled;

      return (
        <>
          {date && (
            <DateTimeDisp
              size="13px"
              utc={(type === "pri" ? row.primaryUTC : row.secondaryUTC) ?? ""}
              utcOffset={row.datecreatedOffset}
              lt={(type === "pri" ? row.primarydate : row.secondarydate) ?? ""}
              disabled={disabled}
              color={color}
              containerProps={{ mb: 4 }}
            />
          )}

          {roles.map((role, i) => (
            <ReviewText
              key={randomId()}
              size="13px"
              blue={blue}
              red={red}
              green={green}
              disabled={disabled}>
              {i === 0 && option ? option + " " + role : role}
            </ReviewText>
          ))}
        </>
      );
    },
    [disabled, row],
  );
  return (
    <Fragment>
      <StyledTd red={red}>{renderRoles("pri")}</StyledTd>
      <StyledTd red={red}>{renderRoles("sec")}</StyledTd>
    </Fragment>
  );
};
export default RolesCells;
